import React from "react";
import { Button, Column, Icon, Modal, Row, Text } from "@amzn/meridian";
import errorTokens from "@amzn/meridian-tokens/base/icon/error";

interface BarcodeConfirmationModalProps {
  open: boolean;
  barcode: string;
  onRescan: () => void;
}

const UnkownObjectBarcodeAlertModal: React.FC<BarcodeConfirmationModalProps> = ({
  open,
  barcode,
  onRescan,
}) => {

  return (
    <Modal open={open} title="Confirm Barcode">
      <Column spacing="500" spacingInset="600" alignmentHorizontal="center">
        <Icon tokens={errorTokens} color="warning" />
        <Column alignmentHorizontal="center">
          <Text type="h300">
            Invalid Barcode
          </Text>
        </Column>

        <Column alignmentHorizontal="center">
          <Text type="b200" alignment="center">
            The barcode scanned does not match a valid container prefix (HAZ, NHZ, UNI, REC, MUN, PHA)
          </Text>
        </Column>

        <Column spacing="200" width="100%">
          <Text type="b200" color="secondary">
            Scanned Barcode:
          </Text>
          <div
            style={{
              padding: "16px",
              backgroundColor: "#F5F5F5",
              borderRadius: "8px",
              border: "1px solid #D3D3D3",
            }}
          >
            <div
              style={{
                fontFamily: "monospace",
                fontSize: "18px",
                wordBreak: "break-all",
                textAlign: "center",
                display: "block",
              }}
            >
              {barcode}
            </div>
          </div>
        </Column>

        <Row spacing="300" width="100%" alignmentHorizontal="center">
          <Button type="secondary" size="large" onClick={onRescan}>
            Rescan
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default UnkownObjectBarcodeAlertModal;
